<template>
  <div class="container-fluid mt-4">
    <div class="card">
      <div class="card-header pb-0">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0 text-dark">Configuración de semanas del programa</h5>
          <button class="btn bg-gradient-info mb-0" @click="addWeek">
            <i class="fas fa-plus me-1" aria-hidden="true"></i> Agregar semana
          </button>
        </div>
        <p class="text-sm text-secondary mb-0">
          Define cuántas semanas tendrá el programa y el rango de fechas (lunes a viernes) de cada una.
          Estas fechas se usan para las asistencias/inasistencias y para validar el registro por QR.
        </p>
      </div>

      <div class="card-body">
        <template v-if="isLoading">
          <p class="text-info">Cargando...</p>
        </template>
        <template v-else>
          <div v-if="weeks.length === 0" class="text-secondary text-sm py-3">
            No hay semanas configuradas. Agrega la primera.
          </div>

          <div v-for="(week, index) in weeks" :key="index" class="row align-items-end mb-3 border-bottom pb-3">
            <div class="col-12 col-md-2">
              <label :for="`week-number-${index}`" class="form-label text-primary text-sm">Semana N°</label>
              <input :id="`week-number-${index}`" type="number" min="1" class="form-control" v-model.number="week.number">
            </div>
            <div class="col-12 col-md-4">
              <label :for="`week-start-${index}`" class="form-label text-primary text-sm">Inicio (lunes)</label>
              <input :id="`week-start-${index}`" type="date" class="form-control" v-model="week.start_date">
            </div>
            <div class="col-12 col-md-4">
              <label :for="`week-end-${index}`" class="form-label text-primary text-sm">Término (viernes)</label>
              <input :id="`week-end-${index}`" type="date" class="form-control" v-model="week.end_date">
            </div>
            <div class="col-12 col-md-2 text-end">
              <button class="btn btn-outline-danger mb-0" :aria-label="`Eliminar semana ${week.number}`" @click="removeWeek(index)">
                <i class="fas fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <button class="btn bg-gradient-success mb-0" :disabled="saving" @click="save">
              {{ saving ? 'Guardando...' : 'Guardar configuración' }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const PUBLIC_API_URL = process.env.VUE_APP_PUBLIC_API_URL;

export default {
  name: 'ConfiguracionesView',
  data() {
    return {
      weeks: [],
      isLoading: false,
      saving: false,
    };
  },
  created() {
    this.fetchWeeks();
  },
  methods: {
    async fetchWeeks() {
      this.isLoading = true;
      try {
        const response = await axios.get(`${PUBLIC_API_URL}/weeks`);
        this.weeks = response.data.map(w => ({
          number: w.number,
          start_date: w.start_date,
          end_date: w.end_date,
        }));
      } catch (error) {
        this.$swal({ title: 'Error', text: 'No pudimos cargar las semanas.', icon: 'error' });
      }
      this.isLoading = false;
    },
    addWeek() {
      const nextNumber = this.weeks.length > 0 ? Math.max(...this.weeks.map(w => w.number)) + 1 : 1;
      this.weeks.push({ number: nextNumber, start_date: '', end_date: '' });
    },
    removeWeek(index) {
      this.weeks.splice(index, 1);
    },
    async save() {
      // Validacion basica en cliente.
      for (const w of this.weeks) {
        if (!w.number || !w.start_date || !w.end_date) {
          this.$swal({ title: 'Datos incompletos', text: 'Completa número y fechas de cada semana.', icon: 'warning' });
          return;
        }
        if (w.end_date < w.start_date) {
          this.$swal({ title: 'Fechas inválidas', text: `La semana ${w.number} tiene término antes del inicio.`, icon: 'warning' });
          return;
        }
      }
      this.saving = true;
      try {
        await axios.post(`${PUBLIC_API_URL}/weeks`, { weeks: this.weeks });
        this.$swal({ title: 'Guardado', text: 'Configuración de semanas actualizada.', icon: 'success' });
        this.fetchWeeks();
      } catch (error) {
        this.$swal({ title: 'Error', text: 'No pudimos guardar la configuración.', icon: 'error' });
      }
      this.saving = false;
    },
  },
};
</script>
